import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import appConfig from 'app-config';

const capabilityPrefix = appConfig.portalCode === 'GPA' ? 'gateway' : '';

export default {
    getVeracityDetailsByJobNumber: (request, additionalHeaders = {}) => {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}veracity`), 'getVeracityDetailsByJobNumber', [request], additionalHeaders);
    }
};
